<fo-preloader></fo-preloader>
<router-outlet></router-outlet>
<notifier-container></notifier-container>